module.exports = __webpack_public_path__ + "static/media/sculptsoft_logo.6169a592.svg";